import pinia from '/@/stores/index';
import { useUserInfo } from '/@/stores/userInfo';
import { App, Directive } from 'vue'

const stores = useUserInfo(pinia);
const { userInfos } = storeToRefs(stores);

// 检查是否有权限
export function hasPermission(permissionCode: string): boolean {
  return userInfos.value.permissionList.some(p => p === permissionCode)
}

// 权限指令
const vPermission: Directive = {
    mounted(el: HTMLElement, binding) {
        if (!hasPermission(binding.value)) {
            el.parentNode?.removeChild(el)
        }
    }
}

// 权限插件
export const permissionPlugin = {
    install(app: App) {
        // 注册全局指令
        app.directive('permission', vPermission)
    }
}